/*
* REDUX Reducers and declaration of original state
*/

import {
  SELECT_SPRITE,
  SELECT_POINTCLOUD,
  SELECT_YEAR,
  SELECT_GROUPING,
  SELECT_LANGUAGE,
  UPDATE_DOMAIN,
  UPDATE_SPRITE_DATA,
  UPDATE_GROUPINGS,
  UPDATE_SEARCH_RESULTS,
  TOGGLE_POINTCLOUD,
  CHANGE_MODE,
  SET_LOADING,
  SET_LOADING_PROGRESS
} from "../actions/index";

import initialState from "../store/initial";

function nqbApp(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_POINTCLOUD: {
      if (action.isShowingPointcloud) {
        return Object.assign({}, state, { isShowingPointcloud: true });
      } else if (typeof action.isShowingPointcloud === "undefined") {
        return Object.assign({}, state, {
          isShowingPointcloud: !state.isShowingPointcloud
        });
      } else {
        return Object.assign({}, state, { isShowingPointcloud: false });
      }
    }
    case SET_LOADING: {
      const loadingFlags = Object.assign({}, state.loading.flags);
      loadingFlags[action.loadingFlag] = action.isLoading;
      return Object.assign({}, state, {
        loading: {
          flags: loadingFlags,
          progress: state.loading.progress
        }
      });
    }
    case SET_LOADING_PROGRESS:
      return Object.assign({}, state, {
        loading: {
          progress: action.progress,
          flags: state.loading.flags
        }
      });
    /*
    * Select sprite, year or groupings
    */
    case SELECT_SPRITE:
      return Object.assign({}, state, {
        selectedSpriteId: action.selectedSpriteId
      });
    case SELECT_YEAR:
      const lenYears = state.selectableYears.length;
      if (action.selectedYearIdx < 0 || action.selectedYearIdx >= lenYears) {
        return state;
      }
      return Object.assign({}, state, {
        selectedYearIdx: action.selectedYearIdx
      });
    case SELECT_GROUPING:
      const indexOfGrouping = state.selectedGroupings.findIndex(
        groupingId => groupingId === action.groupingId
      );
      if (indexOfGrouping > -1) {
        const selectedGroupings = state.selectedGroupings.slice();
        selectedGroupings.splice(indexOfGrouping, 1);
        return Object.assign({}, state, { selectedGroupings });
      }
      const selectedGroupings = state.selectedGroupings.slice();
      selectedGroupings.push(action.groupingId);
      return Object.assign({}, state, { selectedGroupings });
    case SELECT_LANGUAGE:
      return Object.assign({}, state, {
        languageId: action.languageId
      });

    /*
    * Update domain data, grouping data, sprite data or search results to display
    */
    case UPDATE_DOMAIN:
      return Object.assign({}, state, { domain: action.domain });
    case UPDATE_GROUPINGS:
      return Object.assign({}, state, {
        groupings: action.groupings,
        selectedGroupings: action.selected
      });
    case UPDATE_SPRITE_DATA:
      return Object.assign({}, state, {
        selectedSpriteData: action.selectedSpriteData
      });
    case UPDATE_SEARCH_RESULTS: {
      return Object.assign({}, state, {
        searchResults: action.searchResults
      });
    }

    default:
      return state;
  }
}

export default nqbApp;



// WEBPACK FOOTER //
// ./application/frontend/src/reducers/index.js